// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Core__Error = require("./Core__Error.bs.js");

var $$Array;

var Console;

var $$DataView;

var $$Date;

var Dict;

var $$Error;

var Float;

var Int;

var $$BigInt;

var $$Math;

var Null;

var Nullable;

var $$Object;

var Ordering;

var $$Promise;

var $$RegExp;

var $$String;

var $$Symbol;

var Type;

var $$JSON;

var Iterator;

var AsyncIterator;

var $$Map;

var $$WeakMap;

var $$Set;

var $$WeakSet;

var $$ArrayBuffer;

var TypedArray;

var $$Float32Array;

var $$Float64Array;

var $$Int8Array;

var $$Int16Array;

var $$Int32Array;

var $$Uint8Array;

var $$Uint16Array;

var $$Uint32Array;

var $$Uint8ClampedArray;

var $$BigInt64Array;

var $$BigUint64Array;

var $$Intl;

var MapperRt;

var Internal;

var Re;

var Exn;

var $$Option;

var List;

var Result;

var panic = Core__Error.panic;

exports.$$Array = $$Array;
exports.Console = Console;
exports.$$DataView = $$DataView;
exports.$$Date = $$Date;
exports.Dict = Dict;
exports.$$Error = $$Error;
exports.Float = Float;
exports.Int = Int;
exports.$$BigInt = $$BigInt;
exports.$$Math = $$Math;
exports.Null = Null;
exports.Nullable = Nullable;
exports.$$Object = $$Object;
exports.Ordering = Ordering;
exports.$$Promise = $$Promise;
exports.$$RegExp = $$RegExp;
exports.$$String = $$String;
exports.$$Symbol = $$Symbol;
exports.Type = Type;
exports.$$JSON = $$JSON;
exports.Iterator = Iterator;
exports.AsyncIterator = AsyncIterator;
exports.$$Map = $$Map;
exports.$$WeakMap = $$WeakMap;
exports.$$Set = $$Set;
exports.$$WeakSet = $$WeakSet;
exports.$$ArrayBuffer = $$ArrayBuffer;
exports.TypedArray = TypedArray;
exports.$$Float32Array = $$Float32Array;
exports.$$Float64Array = $$Float64Array;
exports.$$Int8Array = $$Int8Array;
exports.$$Int16Array = $$Int16Array;
exports.$$Int32Array = $$Int32Array;
exports.$$Uint8Array = $$Uint8Array;
exports.$$Uint16Array = $$Uint16Array;
exports.$$Uint32Array = $$Uint32Array;
exports.$$Uint8ClampedArray = $$Uint8ClampedArray;
exports.$$BigInt64Array = $$BigInt64Array;
exports.$$BigUint64Array = $$BigUint64Array;
exports.$$Intl = $$Intl;
exports.MapperRt = MapperRt;
exports.Internal = Internal;
exports.Re = Re;
exports.Exn = Exn;
exports.$$Option = $$Option;
exports.List = List;
exports.Result = Result;
exports.panic = panic;
/* No side effect */
